﻿import { IBinder, IValueBinding} from "./ibinder"
import ko from 'knockout';
import $ from 'jquery';

export class RowCountBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find(".et-row-count");
  }

  public getBinding(element: JQuery, data): IValueBinding {
    var compute = (d) => ko.computed({
      read: () => {
        return d.Rows().length;
      }
    }, d);

    return {
      bindingName: "text",
      bindTo: "RowCount",
      dataName: "RowCount",
      dataValue: compute(data)
    }
  }
}
